<template>
  <div class="backup-edit">
    <campaign-backup-explanation :backupType="backupType"></campaign-backup-explanation>
    <loading-icon
        v-if="isLoading"
        loadingIconClasses="campaign-loading">
    </loading-icon>
    <div
        v-if="!isLoading && backupCampaignId"
        :class="['backup-edit__content', { ['backup-edit__content--mms']: !hasAd }, { ['js-has-word-highlight']: showBlacklistModal }]">
      <h5>backup {{backupContentType}} content</h5>
      <campaign-backup-content
          v-if="!isCancelled"
          :hasAd="hasAd"
          :isSmsBackup="isSmsBackup"
          :mmsError="mmsError"
          ref="campaignBackUpContent"
          @getAttachedMedia="getAttachedMedia"
          @updateBackupCampaign="updateBackupCampaign">
      </campaign-backup-content>
      <!--<preview messageModuleName="backup"></preview>
      <deliverability-score
          :messageModuleName="moduleName"
          :style="{ 'padding-top': deliverabilityScoreTopPadding }"
          class="backup-deliverability-score">
      </deliverability-score>-->
    </div>
  </div>
</template>

<script>
  import AxiosMixin from '../../mixins/AxiosMixin'
  import CampaignBackupContent from './CampaignBackupContent'
  import CampaignBackupExplanation from './CampaignBackupExplanation'
  import DeliverabilityScore from '../Message/DeliverabilityScore'
  import LoadingIcon from '../shared/LoadingIcon'
  import { mapActions, mapGetters, mapState } from 'vuex'
  import moment from 'moment-timezone'
  import Preview from '../Message/Preview'
  import DeliverabilityScoreFixMixin from "../../mixins/DeliverabilityScoreFixMixin";

  export default {
    props: {
      parentId: [Number, String],
      shouldCancelBackup: Boolean,
      showBackup: Boolean,
      smsSend: Boolean
    },

    name: 'CampaignBackupEdit',

    components: {
      CampaignBackupContent,
      CampaignBackupExplanation,
      DeliverabilityScore,
      LoadingIcon,
      Preview,
    },

    mixins: [AxiosMixin, DeliverabilityScoreFixMixin],

    data() {
      return {
        moduleName: 'backup',
        allMedia: [],
        attachedMedia: null,
        isCancelled: false,
        isLoading: true,
        mmsError: null,
      }
    },

    methods: {
      backupError(error, extraError) {
        const errorText = extraError?.errorText || 'there was an error with this backup campaign, please refresh or contact support',
          message = error ? `${errorText}. ${error}` : errorText,
          loadErrorAlert = { extraClasses: "error-alert", message }
        this.updateAlerts(extraError.errorType, loadErrorAlert)
        this.isLoading = false
      },

      backupSuccess(data, extraError) {
        const campaign = data?.campaign
        campaign && this.setCampaignData(campaign, extraError)
        !campaign && this.backupError(null, extraError)
        this.isLoading = false
      },

      createOrLoadCampaign() {
        let url = '/api/v3/campaigns/'
        const methodType = this.backupCampaignId ? 'get' : 'post',
          params = this.backupCampaignId ? null : { parent_id: this.parentId },
          errorVerb = this.backupCampaignId ? 'loading' : 'creating',
          errorText = `we encountered an issue ${errorVerb} the backup campaign`,
          onExtraParam = { errorType: `${methodType}Backup`, errorText }
        url = this.backupCampaignId ? url + this.backupCampaignId : url
        this.axiosMethod({methodType, url, params, onSuccess: this.backupSuccess, onError: this.backupError, onExtraParam})
      },

      initBackup() {
        this.createOrLoadCampaign()
        this.getAttachedMedia()
      },

      getAttachedMedia() {
        const url = `/api/v3/campaigns/${this.backupCampaignId}/campaign_attachments`,
          params = { params: { label: ['mms'] } }
        this.axiosMethod({url, params, onSuccess: this.onMmsSuccess, onError: this.onMmsError})
      },

      onMmsError(error) {
        this.mmsError = error ? `issue loading mms: ${error}` : null
        this.$refs?.campaignBackUpContent?.finishGettingAttachedMedia()
      },

      onMmsSuccess(data) {
        const noGoodData = !data || typeof data === 'string',
          hasData = data && typeof data !== 'string',
          shouldUpdateMedia = hasData
        this.allMedia = hasData ? data : []
        this.attachedMedia = hasData && data?.length ? data[0] : null
        shouldUpdateMedia && this.UPDATE_ATTACHED_MEDIA({attachedMedia: data})
        this.mmsError = noGoodData ? 'no mms found' : null
        this.$refs?.campaignBackUpContent?.finishGettingAttachedMedia()
      },

      removeMediaAttachments() {
        if (!!this.attachedMedia) {
          const url = `/api/v3/attachments/${this.attachedMedia.uuid}`,
            methodType = 'delete'
          this.axiosMethod({methodType, url, onSuccess: this.getAttachedMedia})
        }
      },

      setCampaignData(campaignData, extraError) {
        !this.backupCampaignId && this.UPDATE_MESSAGE_ID_TYPE({messageId: campaignData.id, messageType: 'Campaign'})
        this.UPDATE_AD(campaignData?.ad)
        this.UPDATE_MESSAGE_STATE({ stateKey: 'imageType', stateItem: campaignData?.image_type })
        this.isCancelled = !!campaignData.cancelled_at
        this.UPDATE_SMS_CONTENT({ smsContent: campaignData.sms_content })
        this.UPDATE_MESSAGE_STATE({stateKey: 'mockUrl', stateItem: campaignData.mock_url})
        this.updateAlerts(extraError?.errorType, {})
      },

      toggleCancelBackup(shouldCancel) {
        const cancelledAt = shouldCancel?  moment().format("YYYY-MM-DD HH:mm") : null,
          dataToUpdate = { cancelled_at: cancelledAt },
          shouldUpdate = this.isCancelled !== !!cancelledAt
        shouldUpdate && this.updateBackupCampaign(dataToUpdate)
      },

      updateAlerts(itemKey, alert) {
        this.UPDATE_STATE_OBJECT({stateKey: 'alerts', itemKey, itemObject: alert})
      },

      updateBackupAd() {
        if (!this.backupCampaignId) { return }
        const ad_id = this.parentHasAd ? this.parentAdId : null,
          dataToUpdate = { ad_id }
        this.updateImageData(dataToUpdate)
      },

      updateImageData(adData) {
        if (!this.backupCampaignId) { return }
        const image_type = this.isSmsBackup ? 'link' : 'mms',
            dataToUpdate = { image_type, ...adData }
        this.updateBackupCampaign(dataToUpdate)
      },

      updateBackupCampaign(dataToUpdate) {
        const url = `/api/v3/campaigns/${this.backupCampaignId}`,
          methodType = 'patch',
          params = { campaign: dataToUpdate },
          errorText = 'we encountered an issue updating the backup campaign',
          onExtraParam = { errorType: 'campaignUpdate', errorText }
        this.axiosMethod({methodType, url, params, onSuccess: this.backupSuccess, onError: this.backupError, onExtraParam})
      },

      ...mapActions({
        UPDATE_AD: 'backup/UPDATE_AD',
        UPDATE_ATTACHED_MEDIA: 'backup/UPDATE_ATTACHED_MEDIA',
        UPDATE_MESSAGE_ID_TYPE: 'backup/UPDATE_MESSAGE_ID_TYPE',
        UPDATE_MESSAGE_STATE: 'backup/UPDATE_MESSAGE_STATE',
        UPDATE_SMS_CONTENT: 'backup/UPDATE_SMS_CONTENT',
        UPDATE_STATE_OBJECT: 'UPDATE_STATE_OBJECT'
      })
    },

    created() {
      this.backupCampaignId && this.initBackup()
    },

    computed: {
      backupContentType: function () {
        return this.hasAd ? `ad ${this.backupType}` : this.backupType
      },

      backupType: function () {
        return this.isMmsBackup ? 'mms' : 'sms'
      },

      isMmsBackup: function () {
        return this.parentMediaCredits < 1 && (this.parentAdAsLink || !this.parentHasAd)
      },

      isSmsBackup: function () {
        return this.parentMediaCredits > 0 || !this.parentAdAsLink && this.parentHasAd
      },

      ...mapGetters({
        adAsLink: 'backup/adAsLink',
        hasAd: 'backup/hasAd',
        parentAdAsLink: 'message/adAsLink',
        parentAdId: 'message/adId',
        parentHasAd: 'message/hasAd',
        parentMediaCredits: 'message/mediaCredits',
      }),

      ...mapState({
        backupCampaignId: state => state.backup.messageId,
        backupHasBlacklistedWords: state => state.backup.hasBlacklistedWords,
        showBlacklistModal: state => state.backup.showBlacklistModal
      }),
    },

    watch: {
      backupCampaignId: function () {
        !this.isCancelled && this.updateBackupAd()
      },

      backupHasBlacklistedWords: function () {
        this.updateBackupCampaign({ has_blacklisted_words: this.backupHasBlacklistedWords })
      },

      backupType: function () {
        this.updateImageData()
      },

      parentAdId: function () {
        this.updateBackupAd()
        if (this.parentAdId) { this.removeMediaAttachments() }
      },

      shouldCancelBackup: function () {
        !!this.backupCampaignId && this.toggleCancelBackup(this.shouldCancelBackup)
      },

      showBackup: function () {
        const createBackup = this.showBackup && !this.backupCampaignId
        createBackup && this.createOrLoadCampaign()
      },

      smsSend: function () {
        !!this.backupCampaignId && this.toggleCancelBackup(!this.smsSend)
      },
    }
  }
</script>
